export default __webpack_public_path__ + "assets/models/e6423a1b23e00951301471c3071ece78.glb";